// extracted by mini-css-extract-plugin
export default {"profile-setting":"profile-setting_profile-setting__jBeY7","mobile":"profile-setting_mobile__C0f36","notice":"profile-setting_notice__NwkIQ"};